export default "__VITE_ASSET__B2aupKsC__"